import React from 'react';
import withIcon from '../utilities/withIcon';

const IconVideo = () => {
  return (
    <g>
      <path d="m15.4724 3.0515a.75.75 0 0 0 -.7685.0342l-4.0093 2.6443v-2.0589a.75.75 0 0 0 -.75-.75h-9.0615a.75.75 0 0 0 -.75.75v8.6577a.75.75 0 0 0 .75.75h9.0615a.75.75 0 0 0 .75-.75v-2.0588l4.0092 2.6447a.75.75 0 0 0 1.1631-.626v-8.577a.7489.7489 0 0 0 -.3945-.6602zm-6.2778 8.5274h-7.5615v-7.1578h7.5615zm5.1723-.6836-3.6631-2.4165v-.9576l3.6631-2.4165z" />
    </g>
  );
};

export default withIcon(IconVideo);
